// Split: sJumplinks.ts pulls Blade-only CSS into every consumer. Vue callers use this file.
import type { MaybeRefOrGetter } from "vue";

import { tryOnMounted, useEventListener } from "@vueuse/core";
import { shallowRef, toValue, watch } from "vue";

function useJumplinks(ids: MaybeRefOrGetter<readonly string[]>) {
  const activeId = shallowRef<string | null>(toValue(ids).at(0) ?? null);

  function update() {
    const jumplinkIds = toValue(ids);
    const threshold = window.innerHeight / 5;

    activeId.value =
      jumplinkIds.findLast((id) => {
        // oxlint-disable-next-line prefer-query-selector
        const element = document.getElementById(id);

        return (
          element !== null &&
          element.getBoundingClientRect().top - threshold <= 0
        );
      }) ??
      jumplinkIds.at(0) ??
      null;
  }

  useEventListener(["resize", "scroll"], update, { passive: true });

  watch(() => toValue(ids), update, { flush: "post" });

  tryOnMounted(update);

  return { activeId };
}

export { useJumplinks };
